import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=7b0f19ce&scoped=true"
import script from "./ContentItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=7b0f19ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0f19ce",
  null
  
)

export default component.exports